import styled from '@emotion/styled';
import { Button } from '@mui/material';

export const StyledJumpButton = styled(Button)`
  color: #ffc59e;
  font-family: 'Futura New Bold', serif;
  font-size: 1.25rem;
  line-height: 1.25rem;
`;
